import styled from 'styled-components';

const LoaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--colorBlack);
  opacity: 0.5;
  z-index: 99999;
`;

export { LoaderWrapper };
